import Stack from "@p-ban/common/src/components/layout/Stack"

const OneClickFieldStack = ({ children }: { children: React.ReactNode }) => (
  <Stack direction="row" spacing={6} wrapSpacing={8}>
    {children}
  </Stack>
)

export default OneClickFieldStack
